var render, staticRenderFns
import script from "./setMain.vue?vue&type=script&lang=js"
export * from "./setMain.vue?vue&type=script&lang=js"
import style0 from "./setMain.vue?vue&type=style&index=0&id=0c3df983&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3df983",
  null
  
)

export default component.exports